var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTpWorkIcon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M24.5193 9.44219C24.9974 8.76468 26.0022 8.76468 26.4803 9.44219L45.4736 36.3582C46.0345 37.1532 45.466 38.2501 44.4931 38.2501H6.50648C5.53358 38.2501 4.96508 37.1531 5.52601 36.3582L24.5193 9.44219Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5618 46.7503H8.6693C6.2043 46.7503 4.18555 44.774 4.18555 42.3515V10.8165C4.18555 5.249 8.3293 2.72025 13.408 5.2065L22.843 9.839C24.883 10.8378 26.5618 13.494 26.5618 15.7465V46.7503Z",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6862 32.0028V40.0353C46.6862 44.6253 44.5612 46.7503 39.9712 46.7503H26.5625V22.1428L27.5613 22.3553L37.1237 24.5016L41.4375 25.4578C44.2425 26.0741 46.5375 27.5191 46.665 31.5991C46.6862 31.7266 46.6862 31.8541 46.6862 32.0028Z",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 19.1252H19.0613",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 27.6252H19.0613",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.123 24.5015V31.344C37.123 33.979 34.9768 36.1252 32.3418 36.1252C29.7068 36.1252 27.5605 33.979 27.5605 31.344V22.3552L37.123 24.5015Z",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6643 31.599C46.5368 34.1065 44.4543 36.1252 41.9043 36.1252C39.2693 36.1252 37.123 33.979 37.123 31.344V24.5015L41.4368 25.4577C44.2418 26.074 46.5368 27.519 46.6643 31.599Z",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpWorkIcon03);
export default __webpack_public_path__ + "static/media/tp-work-icon03.636286541f99df9e9344d0d6e4d2aa0b.svg";
export { ForwardRef as ReactComponent };